import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenAcsVisitsIndicatorC6Data } from "@/services/esus/indicator/esf/c6/getDetailedCitizensAcsVisitsIndicatorC6";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC6CitizensAcsVisitsHistoryItem } from "./IndicatorEsfC6CitizensAcsVisitsHistoryItem";
import { IndicatorEsfC6CitizensAcsVisitsHistoryInfo } from "./IndicatorEsfC6CitizensAcsVisitsHistoryInfo";

type IndicatorEsfC6CitizensAcsVisitsHistoryProps = {
	citizenWithAcsHomeVisits: DetailedCitizenAcsVisitsIndicatorC6Data;
};

export function IndicatorEsfC6CitizensAcsVisitsHistory({
	citizenWithAcsHomeVisits,
}: Readonly<IndicatorEsfC6CitizensAcsVisitsHistoryProps>) {
	const indicatorEsfC6CitizenHistoryInfo = {
		fullName: citizenWithAcsHomeVisits.fullName ? citizenWithAcsHomeVisits.fullName : "N/A",
		birthdate: citizenWithAcsHomeVisits.birthdate
			? dayjs(citizenWithAcsHomeVisits.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithAcsHomeVisits.birthdate
			? getAge(citizenWithAcsHomeVisits.birthdate)
			: "N/A",
		document: citizenWithAcsHomeVisits.cpf
			? formatIdentifier(citizenWithAcsHomeVisits.cpf)
			: citizenWithAcsHomeVisits.cns ?? "",
		motherName: citizenWithAcsHomeVisits.motherName ?? "",
		phone: citizenWithAcsHomeVisits.phone ? phoneFormat(citizenWithAcsHomeVisits.phone) : "",
		address:
			addressConcat(
				citizenWithAcsHomeVisits.street,
				citizenWithAcsHomeVisits.houseNumber,
				citizenWithAcsHomeVisits.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC6CitizensAcsVisitsHistoryInfo {...indicatorEsfC6CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Visitas"
				timeLineContents={[
					citizenWithAcsHomeVisits.firstAcsHomeVisit,
					citizenWithAcsHomeVisits.lastAcsHomeVisit,
				]
					.filter((homeVisit) => Boolean(homeVisit))
					.map((homeVisit) => homeVisit!)
					.map<TimeLineContent>((homeVisit) => {
						return {
							content: (
								<IndicatorEsfC6CitizensAcsVisitsHistoryItem homeVisit={homeVisit} />
							),
							eventDate: homeVisit.date
								? dayjs(homeVisit.date).format("DD/MM/YYYY")
								: "N/A",
						};
					})}
			/>
		</>
	);
}
